import React from "react";
import Preloader from "../../Global/Preloader";
import Headertwo from "../../Home/Mainhometwo/Headertwo";
import Innerpage from "../../Pages/MenAboutus/Innerpage";
import Aboutus from "../../Pages/MenAboutus/Aboutus";
import Whychooseus from '../../Home/Mainhomeone/Whychooseone';
import Testimonialtwo from "../../Home/Mainhometwo/Testimonialtwo";
import Teamone from "../../Home/Mainhomeone/Teamone";
import Ctaone from "../../Global/Ctaone";
import Footertwo from "../../Home/Mainhometwo/Footertwo";
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return(
        <>
        <Preloader/>
        <Headertwo/>
        <Innerpage/>
        <Aboutus/>
        <Whychooseus/>
        <Testimonialtwo/>
        <Teamone/>
        <Ctaone/>
        <Footertwo/>
        <BackToTop/>
        </>
    )
}
export default Main;